import React from "react";
import { Number } from "../Components";
import { KYCServices } from "../Redux";

import { i18, trb, checkJsonProp, numberFormat } from "./";

const regMail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9])([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
const regPhonePrefix = /^\+\d+$/;
const regPhoneNumber = /^\+\d+$/;

export const composeValidatorsJSON = (validators, form) => value =>
  validators.reduce((error, validator) => error || validator(value, form), undefined);
export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);
export const required = value =>
  value ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldRequired)}</div>
  );
export const requiredAny = value =>
  value ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldsRequired)}</div>
  );
export const requiredAll = value =>
  value ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.AllFieldsRequired)}</div>
  );
export const requiredAndApprove = value =>
  value ? (
    undefined
  ) : (
    <div className="form-field-error text-error">
      {trb(i18.Validations.FieldRequiredAndApprove)}
    </div>
  );
export const requiredNotUndefined = value =>
  value !== undefined ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldRequired)}</div>
  );
export const requiredNotNull = value =>
  value !== null ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldRequired)}</div>
  );
export const requiredApproveCode = value =>
  value ? (
    undefined
  ) : (
    <div className="form-field-error text-error">
      {trb(i18.Validations.FieldRequiredApproveCode)}
    </div>
  );
export const requiredIf = (fieldName, fieldValue = true) => (value, allValues, meta) => {
  const indexOfIndex = fieldName.indexOf("$index");
  if (indexOfIndex > -1) {
    const actualNamePart = meta.name.slice(indexOfIndex),
      actualIndexStr = actualNamePart.split(".")[0],
      actualIndex = parseInt(actualIndexStr),
      realFieldName = fieldName.replace("$index", actualIndex);
    return checkJsonProp(allValues, realFieldName) === fieldValue && !value ? (
      <div className="form-field-error text-error">{trb(i18.Validations.FieldRequired)}</div>
    ) : (
      undefined
    );
  }
  return checkJsonProp(allValues, fieldName) === fieldValue && !value ? (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldRequired)}</div>
  ) : (
    undefined
  );
};
export const requiredIfNot = (fieldName, fieldValue = true) => (value, allValues, meta) => {
  const indexOfIndex = fieldName.indexOf("$index");
  if (indexOfIndex > -1) {
    const actualNamePart = meta.name.slice(indexOfIndex),
      actualIndexStr = actualNamePart.split(".")[0],
      actualIndex = parseInt(actualIndexStr),
      realFieldName = fieldName.replace("$index", actualIndex);
    return checkJsonProp(allValues, realFieldName) !== fieldValue && !value ? (
      <div className="form-field-error text-error">{trb(i18.Validations.FieldRequired)}</div>
    ) : (
      undefined
    );
  }
  return checkJsonProp(allValues, fieldName) !== fieldValue && !value ? (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldRequired)}</div>
  ) : (
    undefined
  );
};

export const checkEmail = value =>
  regMail.test(value) ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldEmail)}</div>
  );
export const checkPhonePrefix = value =>
  regPhonePrefix.test(value) ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldPhonePrefix)}</div>
  );
export const checkPhoneNumber = value =>
  regPhoneNumber.test(value) ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.FieldPhoneNumber)}</div>
  );

export const checkMaxLength = max => value => {
  if (value) {
    return value.length > max ? (
      <div className="form-field-error text-error">
        {trb(i18.Validations.InputIsTooLong) + ":" + trb(i18.Validations.MaxInputIs) + " " + max}
      </div>
    ) : (
      undefined
    );
  }
};

export const checkMinLength = min => value => {
  if (value) {
    return value.length < min ? (
      <div className="form-field-error text-error">
        {trb(i18.Validations.InputIsTooShort) + ":" + trb(i18.Validations.MinInputIs) + " " + min}
      </div>
    ) : (
      undefined
    );
  }
};

export const checkMax = max => value => {
  return value > max ? (
    <div className="form-field-error text-error">
      {trb(i18.Validations.NumberTooBig)}:{" "}
      {<Number value={max} format={numberFormat().currencyWithMinus} text={1} />}
    </div>
  ) : (
    undefined
  );
};

export const checkMin = min => value => {
  return min > value ? (
    <div className="form-field-error text-error">
      {trb(i18.Validations.NumberTooSmall)}:{" "}
      {<Number value={min} format={numberFormat().currencyWithMinus} text={1} />}
    </div>
  ) : (
    undefined
  );
};

export const checkClientBenefShare = valueObj => {
  return valueObj && valueObj.value < valueObj.minValue ? (
    <div className="form-field-error text-error">
      {trb(i18.Validations.ClientBenefShareTooSmall)}:{" "}
      {<Number value={valueObj.minValue} format={numberFormat().currencyWithMinus} text={1} />}
    </div>
  ) : (
    undefined
  );
};

export const isNumeric = n => {
  return !isNaN(parseFloat(n)) && isFinite(n) ? (
    undefined
  ) : (
    <div className="form-field-error text-error">{trb(i18.Validations.IsntNumeric)}</div>
  );
};

export const isnNumeric = n => {
  return !isNaN(parseFloat(n)) && isFinite(n) ? (
    <div className="form-field-error text-error">{trb(i18.Validations.CanntbeNumeric)}</div>
  ) : (
    undefined
  );
};

export const checkPersonCode = code => {
  if (code.length !== 11 || !isNumeric(code)) return false;
  let i, a, b, c, d, e;
  let s = String(code);
  d = 0;
  e = 0;
  b = 1;
  c = 3;
  for (i = 0; i < 10; i++) {
    a = s.charAt(i);
    d = d + b * a;
    e = e + c * a;
    b = b + 1;
    if (b === 10) b = 1;
    c = c + 1;
    if (c === 10) c = 1;
  }
  d = d % 11;
  e = e % 11;
  if (d === 10) {
    if (e === 10) {
      i = 0;
    } else {
      i = e;
    }
  } else i = d;
  return s.charAt(10) === i;
};

export const checkFirmCode = code => {
  if ((code.length === 7 || code.length === 9) && isNumeric(code)) return true;
  return false;
};

export const ignitisElectricCodeIsValid = code => {
  code += "";
  if (code.length !== 8) {
    return false;
  }
  const z = parseInt(code[0]);
  const x1 = parseInt(code[1]);
  const x2 = parseInt(code[2]);
  const x3 = parseInt(code[3]);
  const x4 = parseInt(code[4]);
  const x5 = parseInt(code[5]);
  const x6 = parseInt(code[6]);
  const a = parseInt(code[7]);
  const sum = 2 * z + 7 * x1 + 6 * x2 + 5 * x3 + 4 * x4 + 3 * x5 + 2 * x6;
  let div = sum % 11;
  div = div === 10 ? 0 : div;
  return a === div;
};

export const ignitisGasCodeIsValid = code => {
  code += "";
  if (code.length !== 8) {
    return false;
  }

  const x0 = parseInt(code[0]);
  const x1 = parseInt(code[1]);
  const x2 = parseInt(code[2]);
  const x3 = parseInt(code[3]);
  const x4 = parseInt(code[4]);
  const x5 = parseInt(code[5]);
  const x6 = parseInt(code[6]);
  const a = parseInt(code[7]);
  const sum = 8 * x0 + 7 * x1 + 6 * x2 + 5 * x3 + 4 * x4 + 3 * x5 + 2 * x6;
  let div = sum % 11;
  div = div === 10 ? 0 : div;
  return a === div;
};

// new form validators
export const hasStringValue = value => {
  if (value?.toString()?.trim()) return false;
  return {
    message: trb(i18.Validations.FieldRequired),
    type: "required"
  };
};

// filled and does not exceed certain amount of lenght
export const hasStringValueWithMaxLenght = max => value => {
  if (!(value?.toString()?.trim())){
    return {
      message: trb(i18.Validations.FieldRequired),
      type: "required"
    };
  } else if (value?.length > max){
    return {
      message: `${trb(i18.Validations.InputIsTooLong)}: ${trb(i18.Validations.MaxInputIs)} ${max}`,
      type: "maxLength"
    };
  } 

  return false;
};

export const hasMinLength = min => value => {
  if (value?.length >= min) return false;
  return {
    message: `${trb(i18.Validations.InputIsTooShort)}: ${trb(i18.Validations.MinInputIs)} ${min}`,
    type: "minLength"
  };
};

export const maxLengthNotExceeding = max => value => {
  if (value?.length <= max || !value) return false;
  return {
    message: `${trb(i18.Validations.InputIsTooLong)}: ${trb(i18.Validations.MaxInputIs)} ${max}`,
    type: "maxLength"
  };
};

export const correctPhoneNumber = value => {
  if (regPhoneNumber.test(value)) return false;
  return {
    message: trb(i18.Validations.FieldPhoneNumber),
    type: "phoneNumberFormat"
  };
};

export const correctEmail = value => {
  if (regMail.test(value)) return false;
  return {
    message: trb(i18.Validations.FieldEmail),
    type: "emailFormat"
  };
};

export const requiredIfNotExpectedComparerValue = expectedValue => (fieldValue, compareValue) => {
  if (Array.isArray(expectedValue) && expectedValue.includes(compareValue)) return false;
  if (expectedValue === compareValue) return false;
  return hasStringValue(fieldValue);
};

export const politicsOtherFieldComparer = expectedValue => (fieldValue, compareValue = false) => {
  if (Array.isArray(expectedValue) && expectedValue.includes(compareValue)) return false;
  if (expectedValue === compareValue) return false;
  return hasStringValue(fieldValue);
};

export const isTrue = value => {
  if (value) return false;
  return {
    message: trb(i18.Validations.FieldRequired),
    type: "required"
  };
};

export const notEmpty = value => {
  if (value?.length) return false;
  return {
    message: trb(i18.Validations.FieldRequired),
    type: "required"
  };
};

export const isSelected = value => {
  if (value === undefined || value === "") {
    return {
      message: trb(i18.Validations.FieldRequired),
      type: "requiredSelect"
    };
  }
  return false;
};

export const isMin = min => value => {
  if (+value >= min) return false;
  return {
    message: `${trb(i18.Validations.InputIsTooShort)}: ${trb(i18.Validations.MinInputIs)} ${min}`,
    type: "minNumber"
  };
};

export const isMax = max => value => {
  if (+value <= max || !value) return false;
  return {
    message: `${trb(i18.Validations.InputIsTooLong)}: ${trb(i18.Validations.MaxInputIs)} ${max}`,
    type: "maxNumber"
  };
};

export const validateIdentification = async inputData => {
  const { isValid, isSupported } = await KYCServices.validateData(inputData);

  if (!isValid && !isSupported) return false;

  if (!isValid || !isSupported) {
    return {
      message: trb(i18.Validations.IncorrectID),
      type: "incorrectId"
    };
  }

  return false;
};
